var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedHatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 27,
    viewBox: "0 0 334 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.07 0.237244H158.211V5.411H164.07V0.237244Z",
    fill: "#FB1A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.369 0.237244H187.509V5.411H193.369V0.237244Z",
    fill: "#FB1A50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.263 0.237244H275.404H269.544H263.684V5.411H269.544H275.404H281.263H287.123V0.237244H281.263Z",
    fill: "#FB1A50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.702 0.237244H298.842V5.411H304.702V0.237244Z",
    fill: "#FB1A50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7371 5.41101H46.8773V10.5848H52.7371V5.41101Z",
    fill: "#FB1A50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0352 5.41101H76.1754V10.5848H82.0352V5.41101Z",
    fill: "#FB1A50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6142 10.5848V15.7585H105.474V10.5848H111.333H117.193H123.053V5.411H128.912V0.237244H123.053H117.193H111.333V5.411H105.474V0.237244H99.6142V5.411H93.7544V0.237244H87.8947H82.0352V5.411H87.8947V10.5848H82.0352V15.7585H87.8947H93.7544V10.5848H99.6142Z",
    fill: "#FB1A50"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.509 5.41101H181.649V10.5848H187.509V5.41101Z",
    fill: "#FB1A50"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.228 5.41101H193.369V10.5848H199.228V5.41101Z",
    fill: "#FB1A50"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M287.123 10.5848H281.263H275.404V15.7585H281.263H287.123H292.982V10.5848V5.41101H287.123V10.5848Z",
    fill: "#FB1A50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 5.41101V10.5848V15.7585H334V10.5848V5.41101H328.14Z",
    fill: "#FB1A50"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3158 15.7585H64.4561V10.5848H70.3158V5.411H64.4561V0.237244H58.5966H52.7368V5.411H58.5966V10.5848H52.7368V15.7585V20.9323V26.1058H58.5966V20.9323H64.4561V26.1058H70.3158H76.1754H82.0351V20.9323H76.1754V15.7585V10.5848H70.3158V15.7585Z",
    fill: "#FB1A50"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M146.491 10.5847H140.631H134.772H128.912H123.053V15.7585H128.912H134.772H140.631H146.491V10.5847Z",
    fill: "#FB1A50"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.667 15.7585V10.5848H216.807V5.411H210.947V0.237244H205.088V5.411V10.5848H210.947V15.7585H205.088H199.228H193.369V10.5848H187.509V15.7585H181.649V10.5848H175.79V5.411H169.93H164.07V10.5848H158.211V15.7585H164.07V20.9323V26.1058H169.93H175.79H181.649V20.9323H187.509V26.1058H193.369H199.228H205.088V20.9323H210.947H216.807V15.7585H222.667Z",
    fill: "#FB1A50"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263.684 10.5848H257.825V15.7585H251.965V10.5848H257.825V5.411V0.237244H251.965H246.105H240.246H234.386H228.526H222.667H216.807V5.411H222.667V10.5848H228.526V5.411H234.386H240.246V10.5848H234.386H228.526V15.7585H222.667V20.9323H228.526V26.1058H234.386V20.9323H240.246H246.105V26.1058H251.965V20.9323H257.825H263.684V15.7585V10.5848Z",
    fill: "#FB1A50"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1578 15.7585V10.5847H41.0176V5.41094H35.1578V0.237183H29.2983V5.41094H23.4385V10.5847H29.2983V15.7585H23.4385V10.5847H17.579V5.41094H23.4385V0.237183H17.579H11.7193H5.85973H0V5.41094H5.85973V10.5847H11.7193V15.7585H5.85973V10.5847H0V15.7585V20.9322H5.85973H11.7193V26.1058H17.579V20.9322H23.4385H29.2983H35.1578H41.0176V15.7585H35.1578Z",
    fill: "#FB1A50"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6141 15.7585H93.7543V20.9323V26.1059H99.6141H105.474V20.9323H99.6141V15.7585Z",
    fill: "#FB1A50"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.333 15.7585H105.474V20.9323H111.333V26.1059H117.193V20.9323H123.053V15.7585H117.193H111.333Z",
    fill: "#FB1A50"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.211 15.7585H152.351V20.9323H158.211V15.7585Z",
    fill: "#FB1A50"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M316.421 15.7585V10.5848V5.411H322.281H328.14V0.237244H322.281H316.421H310.561V5.411V10.5848H304.702H298.842V15.7585H304.702H310.561V20.9323H304.702V26.1058H310.561H316.421H322.281V20.9323H316.421V15.7585Z",
    fill: "#FB1A50"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M328.14 15.7585H322.281V20.9323H328.14V15.7585Z",
    fill: "#FB1A50"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8773 20.9323H41.0176V26.106H46.8773V20.9323Z",
    fill: "#FB1A50"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.912 20.9323H123.053V26.106H128.912V20.9323Z",
    fill: "#FB1A50"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M140.632 20.9323H134.772V26.106H140.632V20.9323Z",
    fill: "#FB1A50"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M152.351 20.9323H146.491V26.106H152.351V20.9323Z",
    fill: "#FB1A50"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222.667 20.9323H216.807V26.106H222.667V20.9323Z",
    fill: "#FB1A50"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M269.544 20.9323H263.684V26.1058H269.544H275.404H281.263V20.9323H275.404H269.544Z",
    fill: "#FB1A50"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M292.982 20.9323H287.123V26.106H292.982V20.9323Z",
    fill: "#FB1A50"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M334 20.9323H328.14V26.106H334V20.9323Z",
    fill: "#FB1A50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHatch);
export default __webpack_public_path__ + "static/media/redHatch.95ee824c3634f38d1fdcf8d1eddf21a1.svg";
export { ForwardRef as ReactComponent };